import React, { useState } from 'react';
import styled from 'styled-components';
import { STIcon } from 'components/Brand/Icons/STIcon';
import { Input, InputAdornment } from '@mui/material';
import useBreakpointView from 'utils/useBreakpointView';

export const SearchInput = ({ allowClear, value, handleSearch, autoFocus = false }) => {
  const isMobile = useBreakpointView(['xs', 'sm']);
  const [searchValue, setSearchValue] = useState(value || '');
  const onChange = (e) => {
    handleSearch(e.target.value);
    setSearchValue(e.target.value);
  };

  const onBlur = () => {
    handleSearch(searchValue);
  };

  const onEnterKeyPress = (e) => {
    if (e.keyCode == 13) {
      handleSearch(searchValue);
    }
  };

  return (
    <SearchFieldWrapper className="search-field--wrapper">
      <SearchInputField
        id="search-field--input"
        allowClear={allowClear}
        placeholder="Search"
        startAdornment={
          <InputAdornment>
            <STIcon type="icon-search" fill="#cfd8dc" />
          </InputAdornment>
        }
        {...(isMobile
          ? {
              inputProps: { onBlur: onBlur, onKeyDown: onEnterKeyPress },
              onChange: (e) => setSearchValue(e.target.value),
            }
          : { onChange: onChange })}
        value={searchValue}
        autoFocus={autoFocus}
        fullWidth
        disableUnderline
      />
    </SearchFieldWrapper>
  );
};

const SearchFieldWrapper = styled.div`
  margin-top: 0px;
  margin-left: 0px;
  position: relative;
  font-size: var(--font-size-20);
  width: 400px;
  padding: 4px 11px;

  .MuiInputBase-adornedStart {
    display: flex;
    align-items: center;
  }

  input {
    padding-left: 20px !important;
  }

  @media (max-width: 991px) {
    width: 100%;
  }
  @media (max-width: 767px) {
    margin-top: 5px;
  }
`;

const SearchInputField = styled(Input)`
  font-family: var(--font-family-body) !important;
  border-radius: 0px !important;
  font-size: var(--font-size-20) !important;
  letter-spacing: 1.1px;
`;
